'use client';

import { MultiStepForm } from './components/MultiStepForm';
import { invoiceFinanceEnquireFormConfig } from './InvoiceFinanceEnquireFormConfig';

export const InvoiceFinanceEnquireForm = () => {
  return (
    <MultiStepForm config={invoiceFinanceEnquireFormConfig} />
  );
}; 